// src/pages/auth/verificationSent.js

const VerificationSent = () => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
      }}
    >
      <h2>Verification Email Sent</h2>
      <p>
        A verification email has been sent to your inbox. Please check your email and follow the
        instructions to verify your account.
      </p>
    </div>
  );
};

export default VerificationSent;
